import type { ConfigFieldContext } from '../ConfigFields/ConfigFields'
import cn from '../ConfigModal.module.scss'
import type { ConfigSourceType } from '../lib/configFormModel'
import ImportProtectionFields from './ImportProtectionFields/ImportProtectionFields'
import TextQuantityMappingField from './TextQuantityMappingField/TextQuantityMappingField'

type ConfigRulesFieldsProps = {
  context: ConfigFieldContext
  sourceType: ConfigSourceType
}

function ConfigRulesFields({ context, sourceType }: ConfigRulesFieldsProps) {
  return (
    <>
      <p className={cn.sectionTitle}>Фильтры и правила</p>
      <ImportProtectionFields context={context} sourceType={sourceType} />
      <TextQuantityMappingField context={context} />
    </>
  )
}

export default ConfigRulesFields
